import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'ORBRO ứng dụng Digital Twin để triển khai thông tin khí quyển và khí tượng, qua đó hỗ trợ việc tìm hiểu và thích ứng với biến đổi khí hậu. Thông qua giám sát thời tiết và các mô phỏng tiên tiến, ORBRO cung cấp các phân tích khí hậu và thông tin đa dạng được ứng dụng trong nhiều lĩnh vực rộng lớn.',
  keywords: 'Bản sao số, thông tin khí tượng, thành phố số, thực tế ảo, ban sao so, thong tin khi tuong, thanh pho so, thuc te ao.',
  ogSite: 'Digital Twin  - Xây dựng thông tin khí quyển và khí tượng',
  title: 'Digital Twin  - Xây dựng thông tin khí quyển và khí tượng',
  ogUrl: 'https://orbro.io/vi/blog/digitaltwin-weather',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDmsHKPo0k1JGpYe5RqcLPvhvPsttOE54okj7zmGDmBsNO7w1O-JK1oTjUeN0SXoXeuVHVRR0yqY597xyclhreNiwqO8zxMhslWsAccGNFJL7Cc4jphNGY1U-ApF8rYUJlkQ29hCvXhs1-kJ7ItJ8yzqul6tD2bkCeeSf24qL0tmKPNG7wJdcdkE8HnxTJ-dAJvm-HQ1tD8-RFPjUfTcllJI-RCb7dzd6jATNYzQbe1GQD7gejTG574T2T6jKa1sIQLT1me2evIreAszenpfb2ZOAOafbrlQEnfJCF577BDuUZxdtYW-PpTWZdcoK_GlrZTVEXWFVIe4zYY4BA9uI-4MvLCytQ19heux-zPZ2uj0Pd-eu04szV3P6TFIG2dqGtdzui7sXRbRh4-9toRM1UEYley9vu4sOHPbxuwV1LN97GHKbtKrmz4OsgOS0jK8VWR0v_KCwr08MXIduU_b2QT5axXUH4CSftoADRRfaDprmZIqjdAdy7RqILvmsg_V7NQAcd9xapuxx4MMoC42nj2n0iwd9yZV--15jzcgqW6daHUiYEZ4ggt7Uy2LoPScqjh7hhOm8vT1XPj6fSf3W1SgBduBXU9h5e0_bG9GKZLWMCy72SHi0Xs0NO0X7FSOgdDU0scaP-F8WlOsTezavpMEhxUlz2fhL_mBIfZVO25KKS-y-Qfuul0bpf2coLNtuVO4yW_hZEZuAzW7FbuIUdoyI04V7I493a1IXz6-A_ZcTH2j2retDHu_nD6RnBrnlcCsY0tnVCMM0ho0k_GLGaGTrs_88IPxii47Y_Qa1XXH-8-wwpGN0UocvGhXB6rdM7S-m7_MIT3ONC4MyvE3Bqjkid-QLeYtThJ2zXLCXfCIaCyi4jttco-MJjx84qBVRrUWpwcvpISJ7E9pYCJukWT1rgVNPsgO1baez2jR2IyH1hMZ4SXB6nHNVoylyuvAjn1uYfjDCfOgRlqmcK8wt3U1GImqc68KthjcbhAjDNmlLNtBl9Pd4Ksg0Xts8R_Z_LbV6Ue834BoCmu5H_jzmEevCkvwPsYoLsmqebwEqmrp2B58f2e32e0YY8L8jPuMPX3UDZyxX98adUK-gekxc1YB5JrqJPlcC4nZA-XLh8EmakSbt83hYYjIkhbHeafd7Hr5M-Em9znV_sFo2DaAwfkAQRoa80pNidI39UxDJVdey6nVP9H6UPL-i_N-H1K6LpiALIwQNKPMlI4up5e-hme40ZgUL9QKbBaKDyfOxk1aqml1cTzHCZJRP_jLw2dOoS1K-EG7OsGJDxmnclokA0StmKuFCPLAbAodPa1K_Btbk2GtITh4kvm07TLOp_LDZBnztDlzA8WuId3bEWiXNRc5qKlfv5UYlEn_k4L03K4A-T49R-Pi75Jp53wW68HhGwDoSbyYjaiI8plzJeyMyGJduXJZtYWh66ETIXdt8IxUDYw5otbzXD-lFsSLdM09U37NH_lU0c07Sjg77a4m1OfI1-mfJmHzqzvn9kksa3H2aYES0HhIq5RPgdd0NyW7b2IvL9b7nDE4tL4D-hf70biexJ_aaBkb=w1923-h1074',
  ogType: 'website',
  date: '2023-12-26',
  tag1: '#Bansaoso',
  tag2: '#Thongtinkhituong',
  tag3: '#Thanhphoso',
  tag4: '#Thucteao',
  text: [
    {
      head: 'Digital Twin - Triển khai Thông tin Khí quyển và Khí tượng',
      subHead: '',
      desc: 'ORBRO ứng dụng Digital Twin để triển khai thông tin khí quyển và khí tượng, qua đó hỗ trợ việc tìm hiểu và thích ứng với biến đổi khí hậu. Thông qua giám sát thời tiết và các mô phỏng tiên tiến, ORBRO cung cấp các phân tích khí hậu và thông tin đa dạng được ứng dụng trong nhiều lĩnh vực rộng lớn.\nMôi trường khí tượng ngày và đêm, môi trường khí hậu và lượng mưa, dữ liệu khí tượng hải dương, thông tin khí tượng toàn cầu, giám sát ô nhiễm không khí, hệ thống dự báo và cảnh báo thiên tai cung cấp những thông tin thiết yếu cho nghiên cứu khí hậu, hoạch định nông nghiệp, quản lý tài nguyên nước, v.v.\nDữ liệu từ vệ tinh khí tượng, thông tin về lượng nắng và vị trí mặt trời được sử dụng để mô phỏng môi trường khí tượng ngày và đêm theo thời gian thực; các mô hình khí tượng độ phân giải cao và dữ liệu lượng mưa được dùng để mô phỏng các điều kiện khí hậu. Việc biểu diễn lượng mưa trên biển, tích hợp thông tin khí tượng toàn cầu, giám sát ô nhiễm không khí, cùng các hệ thống dự báo và cảnh báo thiên tai đóng vai trò quan trọng trong hải dương học, nghiên cứu khí hậu, y tế công cộng và bảo vệ môi trường.',
      dot: '',
    },
    {
      head: 'Diễn đạt môi trường khí tượng ngày và đêm',
      subHead: '',
      desc: 'ORBRO mô phỏng môi trường khí tượng ngày và đêm theo thời gian thực bằng cách sử dụng dữ liệu từ vệ tinh khí tượng, thông tin về lượng nắng và vị trí mặt trời. Điều này cung cấp dữ liệu quan trọng cho nghiên cứu khí hậu, quản lý thiên tai, hoạch định nông nghiệp và quản lý năng lượng.',
      dot: '',
    },
    {
      head: 'Diễn đạt môi trường khí hậu và lượng mưa',
      subHead: '',
      desc: 'ORBRO sử dụng các mô hình khí tượng độ phân giải cao và dữ liệu lượng mưa để mô phỏng các điều kiện khí hậu đa dạng theo thời gian thực. Điều này cung cấp dữ liệu quan trọng cần thiết cho nghiên cứu khí hậu, hoạch định nông nghiệp và quản lý tài nguyên nước.',
      dot: '',
    },
    {
      head: 'Biểu hiện lượng mưa trên biển',
      subHead: '',
      desc: 'ORBRO trực quan hóa các hiện tượng mưa tại các khu vực biển bằng cách sử dụng dữ liệu khí tượng hải dương từ vệ tinh và các mô hình hải dương. Thông tin này cung cấp dữ liệu quan trọng cần thiết cho hải dương học, nghiên cứu khí hậu, giao thông hàng hải và quản lý an toàn trên biển.',
      dot: '',
    },
    {
      head: 'Tích hợp thông tin khí tượng toàn cầu',
      subHead: '',
      desc: 'ORBRO thu thập và phân tích thông tin khí tượng trên phạm vi rộng bằng cách tích hợp dữ liệu từ các trạm quan trắc khí tượng và vệ tinh trên toàn thế giới. Điều này đóng vai trò thiết yếu trong việc giám sát biến đổi khí hậu toàn cầu và ứng phó với thiên tai quốc tế.',
      dot: '',
    },
    {
      head: 'Giám sát ô nhiễm không khí',
      subHead: '',
      desc: 'ORBRO theo dõi và dự đoán chất lượng không khí cũng như mức độ ô nhiễm để hỗ trợ các chính sách y tế công cộng và bảo vệ môi trường. Điều này cung cấp thông tin quan trọng cho việc cải thiện chất lượng không khí và phòng chống ô nhiễm.',
      dot: '',
    },
    {
      head: 'Hệ thống dự báo và cảnh báo thiên tai',
      subHead: '',
      desc: 'ORBRO sử dụng dữ liệu khí tượng để dự báo các thảm họa tự nhiên và phát triển các hệ thống cảnh báo liên quan. Hệ thống này cải thiện công tác chuẩn bị và ứng phó với thiên tai, đồng thời cho phép phản ứng nhanh chóng trước các thảm họa tự nhiên.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
